<template>
  <div>
    <div class="container">
      <div class="handle-box">
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item label="类型">
            <el-select
              v-model="channel"
              style="width: 200px"
              class="handle-select mr10"
              @change="selectHandle"
            >
              <el-option
                v-for="(child, index) in channels"
                :key="index"
                :label="child.name"
                :value="child.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="设备">
            <el-select
              v-model="device"
              style="width: 200px"
              class="handle-select mr10"
              @change="selectdeviceHandle"
            >
              <el-option
                v-for="(child, index) in devices"
                :key="index"
                :label="child.name"
                :value="child.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="环境">
            <el-select
              v-model="dev_mode"
              style="width: 200px"
              class="handle-select mr10"
              @change="selectdeModeHandle"
            >
              <el-option
                v-for="(child, index) in dev_modes"
                :key="index"
                :label="child.name"
                :value="child.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-input
            v-model="keywords"
            placeholder="请输入版本号、更新内容"
            class="handle-input mr10"
          ></el-input>
          <el-button
            type="primary"
            icon="el-icon-search"
            class="mr10"
            @click="handleSearch"
            >搜索</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-lx-add"
            class="handle-add"
            @click="handleEdit(null, true)"
            >新增
          </el-button>
        </el-form>
      </div>
      <el-table
        :data="tableData"
        border
        class="table"
        ref="multipleTable"
        header-cell-class-name="table-header"
        v-loading="loading"
      >
        <el-table-column label="序号" align="center" width="50">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 + page_index }}</span>
          </template>
        </el-table-column>
        <el-table-column label="客户端" align="center">
          <template slot-scope="scope">{{
            getChannelType(scope.row.channel)
          }}</template>
        </el-table-column>
        <el-table-column label="设备" align="center">
          <template slot-scope="scope">{{
            getdeviceType(scope.row.device)
          }}</template>
        </el-table-column>
        <el-table-column
          prop="version"
          label="版本号"
          align="center"
        ></el-table-column>
        <el-table-column prop="version" label="环境" align="center">
          <template slot-scope="scope">{{
            getDev(scope.row.dev_mode)
          }}</template>
        </el-table-column>
        <el-table-column
          prop="description"
          label="更新说明"
          align="center"
        ></el-table-column>
        <el-table-column label="本次是否强制更新" align="center">
          <template slot-scope="scope">{{
            getType(scope.row.must_update)
          }}</template>
        </el-table-column>
        <el-table-column label="本次是否弹出更新框" align="center">
          <template slot-scope="scope">{{
            getType(scope.row.show_update)
          }}</template>
        </el-table-column>
        <el-table-column label="启用状态" align="center">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.enable">已启用</el-tag>
            <el-tag type="danger" v-else>未启用</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="240" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              v-if="!scope.row.enable"
              icon="el-icon-edit"
              @click="enableEdit(scope.row, 1)"
              >启用
            </el-button>
            <el-button
              type="text"
              icon="el-icon-edit"
              v-if="!scope.row.enable"
              @click="handleEdit(scope.row, false)"
              >修改
            </el-button>
            <el-button
              type="text"
              icon="el-icon-delete"
              v-if="!scope.row.enable"
              @click="handleDelete(scope.row)"
              >删除
            </el-button>
            <el-button type="text" @click="handleDownload(scope.row)"
              >下载</el-button
            >
            <el-button
              v-if="scope.row.meizu_url != ''"
              type="text"
              @click="handleDownload(scope.row)"
              >魅族下载</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination" v-if="totalPages > 1">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="currentPage"
          :page-size="page_size"
          :total="pageTotal"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>

    <!-- 编辑弹出框 -->
    <el-dialog
      :visible.sync="editVisible"
      width="50%"
      :close-on-click-modal="false"
    >
      <el-form ref="ruleForm" :model="form" :rules="rules" label-width="180px">
        <el-form-item label="客户端：" prop="channel">
          <el-select v-model="fchannel" class="handle-select">
            <el-option
              v-for="(child, index) in window_channels"
              :key="index"
              :label="child.name"
              :value="child.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备：" prop="device">
          <el-select
            v-model="fdevice"
            class="handle-select"
            @change="changeValue"
          >
            <el-option
              v-for="(child, index) in window_devices"
              :key="index"
              :label="child.name"
              :value="child.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="环境：" prop="dev_mode">
          <el-select v-model="fdev_mode" class="handle-select">
            <el-option
              v-for="(child, index) in window_devmode"
              :key="index"
              :label="child.name"
              :value="child.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="本次是否强制更新：" prop="device">
          <el-select v-model="must_update" class="handle-select">
            <el-option
              v-for="(child, index) in window_must_update"
              :key="index"
              :label="child.name"
              :value="child.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="本次是否显示弹窗：" prop="device">
          <el-select v-model="show_update" class="handle-select">
            <el-option
              v-for="(child, index) in window_show_update"
              :key="index"
              :label="child.name"
              :value="child.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上传：" prop="download_url" :rules="fdevice == 2">
          <el-upload
            class="avatar-uploader"
            action
            :show-file-list="false"
            :before-upload="beforeAvatarUpload"
          >
            <p v-if="form.download_url" class="avatar">
              {{ form.download_url }}
            </p>
            <em
              v-show="!form.download_url && !uploading"
              class="el-icon-plus avatar-uploader-icon"
            ></em>
            <em
              class="el-icon-loading avatar-uploader-icon"
              v-show="uploading"
            ></em>
          </el-upload>
        </el-form-item>
        <el-form-item
          label="版本号："
          prop="apk_version"
          :rules="[
            { required: true, validator: versionCheck, trigger: 'blur' },
          ]"
          v-if="is_add"
        >
          <el-input v-model="form.apk_version" :disabled="disabled"></el-input>
          <!-- <span>{{form.apk_version}}</span> -->
        </el-form-item>
        <el-form-item
          label="版本号："
          prop="version"
          :rules="[
            { required: true, validator: versionCheck, trigger: 'blur' },
          ]"
          v-else
        >
          <el-input v-model="form.version" @input="onInput()"></el-input>
        </el-form-item>
        <el-form-item label="更新说明：" prop="description">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 8 }"
            v-model="form.description"
            @input="onInput()"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer self-dialog-footer">
        <el-button type="primary" @click="saveEdit('ruleForm')"
          >提 交</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { _ } from "vue-underscore";
import http from "../../../api/hemeraApiConfig";
// import http2 from "../../../api/uploadApiConfig";
import $ from "jquery";
import VUE_APP_API_HEMERA_URL from "../../../api/getapi/hemera";

export default {
  name: "Msglist",
  data() {
    return {
      channels: [
        { id: "", name: "全部" },
        { id: 1, name: "家庭中医馆" },
        { id: 2, name: "中医智库" },
      ],
      devices: [
        { id: "", name: "全部" },
        { id: 1, name: "Android" },
        { id: 2, name: "IOS" },
      ],
      dev_modes: [
        { id: 1, name: "开发环境" },
        { id: 2, name: "正式环境" },
      ],
      window_channels: [
        { id: 1, name: "家庭中医馆" },
        { id: 2, name: "中医智库" },
      ],
      window_devices: [
        { id: 1, name: "Android" },
        { id: 2, name: "IOS" },
      ],
      window_devmode: [
        { id: 1, name: "开发环境" },
        { id: 2, name: "正式环境" },
      ],
      window_must_update: [
        { id: 1, name: "是" },
        { id: 0, name: "否" },
      ],
      window_show_update: [
        { id: 1, name: "是" },
        { id: 0, name: "否" },
      ],
      channel: "",
      device: "",
      fchannel: 1,
      fdevice: 1,
      fdev_mode: 1,
      dev_mode: 1,
      must_update: 1,
      show_update: 1,
      keywords: "",
      select_id: "",
      tableData: [],
      currentPage: 1,
      totalPages: 1,
      page_size: 10,
      pageTotal: 10,
      page_index: 10,
      keyword: "",
      downloadUrl: "",
      work_path: "common/apkversions",
      loading: false,
      is_add: false,
      editVisible: false,
      uploading: false,
      disabled: true,
      form: {},
      url: "",
      rules: {
        channel: [{ required: true, message: "请选择客户端", trigger: "blur" }],
        download_url: [
          { required: true, message: "请上传安装包", trigger: "blur" },
        ],
        apk_version: [
          { required: true, message: "请填写版本号", trigger: "blur" },
        ],
        version: [{ required: true, message: "请填写版本号", trigger: "blur" }],
        description: [
          { required: true, message: "请填写更新说明", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.getData();
  },
  methods: {
    versionCheck(rule, value, callback) {
      let re = new RegExp(/^([1-9]\d|[1-9])(\.([1-9]\d|\d)){2}$/);
      if (value.length == 0) {
        callback(new Error("版本号不能为空"));
      } else if (!re.test(value)) {
        callback(new Error("请填写正确的版本号"));
      } else {
        callback();
      }
    },
    getDownloadPath(path) {
      return path.replace(this.work_path + "/", "");
    },
    getChannelType(id) {
      let item = _.filter(this.window_channels, function (selector) {
        return selector.id === id;
      })[0];
      if (item) {
        return item["name"];
      } else {
        return "";
      }
    },
    getdeviceType(id) {
      let item = _.filter(this.window_devices, function (selector) {
        return selector.id === id;
      })[0];
      if (item) {
        return item["name"];
      } else {
        return "";
      }
    },
    getType(id) {
      if (id == 1) {
        return "是";
      } else {
        return "否";
      }
    },
    getDev(id) {
      if (id == 1) {
        return "开发环境";
      } else {
        return "正式环境";
      }
    },
    onInput() {
      this.$forceUpdate();
    },
    getData() {
      let that = this;
      that.loading = true;
      let params = {
        page: that.currentPage,
        page_size: that.page_size,
      };
      if (that.channel) {
        params["channel"] = that.channel;
      }
      if (that.device) {
        params["device"] = that.device;
      }
      if (that.keywords) {
        params["keywords"] = that.keywords;
      }
      if (that.dev_mode) {
        params["dev_mode"] = that.dev_mode;
      }
      http.get("admin/versions", { params: params }).then(function (res) {
        that.page_index = (that.currentPage - 1) * that.page_size;
        that.tableData = res.data.data.items;
        that.currentPage = res.data.data.page;
        that.totalPages = res.data.data.total_pages;
        that.pageTotal = that.totalPages * that.page_size;
        that.loading = false;
      });
    },
    selectHandle() {
      this.currentPage = 1;
      this.getData();
    },
    selectdeModeHandle() {
      this.currentPage = 1;
      this.getData();
    },
    selectdeviceHandle() {
      this.currentPage = 1;
      this.getData();
    },
    selectczHandle() {},
    handleSearch() {
      this.currentPage = 1;
      this.getData();
    },
    handlePageChange(val) {
      this.currentPage = val;
      this.getData();
    },
    changeValue(e) {
      console.log(e);
      if (e == 2) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    },
    handleDelete(row) {
      let that = this;
      // 二次确认删除
      that
        .$confirm("确定要删除吗？", "提示", {
          type: "warning",
        })
        .then(() => {
          http.delete("admin/versions/" + row.id).then(function (res) {
            if (res.data.status_code == 200) {
              that.$message.success("删除成功");
              that.getData();
            }
          });
        })
        .catch(() => {});
    },
    enableEdit(row, enable) {
      let that = this;
      let params = { enable: enable };
      if (row.enable) {
        that
          .$confirm("是否关闭启用?", "提示", {
            type: "warning",
          })
          .then(() => {
            http.put("admin/versions/" + row.id, params).then(function (res) {
              // console.log(res);
              if (res.data.status_code == 200) {
                that.$message.success("关闭成功");
                that.getData();
              }
            });
          })
          .catch(() => {});
      } else {
        that
          .$confirm("是否启用?", "提示", {
            type: "warning",
          })
          .then(() => {
            http.put("admin/versions/" + row.id, params).then(function (res) {
              // console.log(res);
              if (res.data.status_code == 200) {
                that.$message.success("启用成功");
                that.getData();
              }
            });
          })
          .catch(() => {});
      }
    },
    handleEdit(row, add) {
      this.is_add = add;
      if (add) {
        this.form = {
          download_url: "",
          apk_version: "",
          description: "",
        };
        if (this.channel == "") {
          this.form["channel"] = 1;
        } else {
          this.form["channel"] = this.channel;
        }
      } else {
        this.form = {
          id: row.id,
          enable: row.enable,
          download_url: row.download_url,
          channel: row.channel,
          version: row.version,
          description: row.description,
        };
      }
      this.editVisible = true;
    },
    beforeAvatarUpload(file) {
      let that = this;
      const isPackage = file.type === "application/vnd.android.package-archive";
      if (isPackage) {
        var ossData = new FormData();
        ossData.append("file", file);
        that.uploading = true;
        let apiURL = "";
        // console.log(process.env.NODE_ENV)
        if (process.env.NODE_ENV === "development") {
          // alert("开发环境");
          apiURL = "http://proxy.jiankanghao.net:50208/api/v1/";
        } else {
          // alert("生产环境");
          apiURL = VUE_APP_API_HEMERA_URL;
        }
        let url = apiURL + "admin/versions/files";
        $.ajax({
          url: url,
          type: "POST",
          data: ossData,
          contentType: false,
          processData: false,
          headers: {
            Authorization: localStorage.getItem("ms_token"),
          },
          success: function (data) {
            console.log(data);
            if (data.status_code == 200) {
              that.url = data.data.url;
              that.form.download_url = data.data.url;
              that.uploading = false;
              const appInfoParser = require("app-info-parser");
              const parser = new appInfoParser(file);
              parser
                .parse()
                .then((result) => {
                  that.form.apk_version = result.versionName;
                })
                .catch((err) => {
                  console.log("err ----> ", err);
                });
            } else {
              alert("上传失败");
            }
          },
          error: function () {
            console.log("上传失败！");
          },
        });
      } else if (!isPackage) {
        this.$message.error("上传文件不是安装包");
      }
      return isPackage;
    },
    saveEdit(formName) {
      let that = this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            channel: that.fchannel,
            device: that.fdevice,
            dev_mode: that.fdev_mode,
            description: that.form.description,
            must_update: that.must_update,
            show_update: that.show_update,
          };
          if (that.is_add) {
            params["download_url"] = that.url;
            params["apk_version"] = that.form.apk_version;
            http.post("admin/versions", params).then(function (res) {
              if (res.data.status_code == 200) {
                that.$message.success(`新增成功`);
                that.getData();
              } else if (res.data.status_code == 500) {
                that.$message.error(res.data.msg);
              }
            });
          } else {
            params["enable"] = that.form.enable;
            params["version"] = that.form.version;
            params["download_url"] = that.form.download_url;
            http
              .put("admin/versions/" + that.form.id, params)
              .then(function (res) {
                if (res.data.status_code == 200) {
                  that.$message.success(`修改成功`);
                  that.getData();
                } else if (res.data.status_code == 500) {
                  that.$message.error();
                  res.data.msg;
                }
              });
          }
          that.editVisible = false;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleDownload(row) {
      window.location.href = row.download_url;
    },
  },
};
</script>

<style scoped>
.handle-box {
  margin-bottom: 20px;
}

.handle-select {
  width: 120px;
}

.handle-input {
  width: 300px;
  display: inline-block;
}

.table {
  width: 100%;
  font-size: 14px;
}

.red {
  color: #ff0000;
}

.mr10 {
  margin-right: 10px;
}

.table-td-thumb {
  display: block;
  margin: auto;
  width: 40px;
  height: 40px;
}

.avatar {
  height: 178px;
  line-height: 178px;
  display: block;
  max-width: 100%;
  text-align: center;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.self-dialog-footer {
  display: block;
  text-align: center;
}
</style>
